import { css } from 'lit';
export default css `
  :host {
    width: 100%;
    max-height: 280px;
    overflow: scroll;
    scrollbar-width: none;
  }

  :host::-webkit-scrollbar {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map